<template>
  <div style="overflow: hidden">
    <div class="wrapper_all wrapper_app_job">
      <div class="head">
        <div></div>
        <div
          :class="{ active_head_color: active_head == 1 }"
          @click="
            active_head = 1;
            getQs_pageNum = 1;
            get_myDiscussList();
          "
        >
          作业习题
        </div>
        <div
          :class="{ active_head_color: active_head == 2 }"
          @click="
            active_head = 2;
            getQs_pageNum = 1;
            get_myFollowList();
          "
        >
          自由问答
        </div>
        <div></div>
      </div>
      <div class="content_box">
        <div class="content_box_search">
          <div class="course_search">
            <el-input
              placeholder="请输入名称"
              v-model="keyword"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="btnsearch"
                style="border-radius: 50%"
              ></el-button>
            </el-input>
          </div>
          <div style="display: flex">
            <div>
              <el-popover
                placement="bottom"
                trigger="click"
                popper-class="area_popper_course"
                v-model="popover_sort_show"
              >
                <div
                  slot="reference"
                  class="course_creat_sort_btn"
                  style="cursor: pointer"
                >
                  {{ sort_time }}-{{ sort_type }}
                  <i
                    :class="
                      popover_sort_show
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                  ></i>
                </div>
                <div class="course_creat_sort_options" v-if="active_head == 1">
                  <div class="course_creat_sort_options_disable">查看类型</div>
                  <div
                    :class="{ color_active: sort_time == '全部' }"
                    @click="change_sort_time('全部')"
                  >
                    全部
                  </div>
                  <div
                    :class="{ color_active: sort_time == '习题' }"
                    @click="change_sort_time('习题')"
                  >
                    习题
                  </div>
                  <div
                    :class="{ color_active: sort_time == '作业' }"
                    @click="change_sort_time('作业')"
                  >
                    作业
                  </div>

                  <div class="course_creat_sort_options_disable">筛选排序</div>
                  <div
                    :class="{ color_active: sort_type == '最多浏览' }"
                    @click="change_sort_type('最多浏览')"
                  >
                    最多浏览
                  </div>
                  <div
                    :class="{ color_active: sort_type == '最多回复' }"
                    @click="change_sort_type('最多回复')"
                  >
                    最多回复
                  </div>
                  <div
                    :class="{ color_active: sort_type == '最新更新' }"
                    @click="change_sort_type('最新更新')"
                  >
                    最新更新
                  </div>
                  <div
                    :class="{ color_active: sort_type == '最新时间' }"
                    @click="change_sort_type('最新时间')"
                  >
                    最新时间
                  </div>
                </div>
                <div class="course_creat_sort_options" v-if="active_head == 2">
                  <div
                    :class="{ color_active: sort_type_2 == '默认' }"
                    @click="change_sort_type_2('默认')"
                  >
                    默认
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最新发布' }"
                    @click="change_sort_type_2('最新发布')"
                  >
                    最新发布
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最多关注' }"
                    @click="change_sort_type_2('最多关注')"
                  >
                    最多关注
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最多回复' }"
                    @click="change_sort_type_2('最多回复')"
                  >
                    最多回复
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最新浏览' }"
                    @click="change_sort_type_2('最新浏览')"
                  >
                    最新浏览
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最新更新' }"
                    @click="change_sort_type_2('最新更新')"
                  >
                    最新更新
                  </div>
                  <div
                    :class="{ color_active: sort_type_2 == '最新时间' }"
                    @click="change_sort_type_2('最新时间')"
                  >
                    最新时间
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
        <div class="content_list_box" id="list_box" v-if="total != 0">
          <div
            class="content_list_item"
            v-for="(item, index) in myDiscussList"
            :key="index"
            @click="to_coach_forum(item)"
          >
            <div class="content_list_item_title">{{ item.title }}</div>
            <div class="content_list_item_content" v-html="item.abstract"></div>
            <div class="content_list_item_content" v-if="item.img_list">图片内容</div>
            <div class="content_list_item_content" v-if="item.replay_video_url">视频内容</div>
            <div class="content_list_item_content" v-if="item.reply_audio_url">音频内容</div>
            <div class="content_list_item_foot">
              <div>
                <span class="iconfont iconchakan"></span
                ><span style="opacity: 0">1</span>{{ item.discuss_view_num }}
              </div>
              <div>
                <span class="iconfont iconai-message"></span
                ><span style="opacity: 0">1</span>{{ item.discuss_content_num }}
              </div>
              <div v-show="active_head == 2">
                <span class="iconfont iconai-message"></span
                ><span style="opacity: 0">1</span>{{ item.follow_num }}
              </div>
              <div>{{ TimestampToTime(item.createtime) }}</div>
            </div>
            <div class="item_type">{{ item.type == 1 ? "习题" : "作业" }}</div>
          </div>
        </div>
        <div class="course_card_empty" v-if="total == 0"></div>
        <div class="content_list_page">
          <el-pagination
            background
            v-if="total != 0"
            layout="prev, pager, next"
            :page-size="pageSize"
            :total="total"
            @current-change="changePage"
            :current-page="getQs_pageNum"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  changeData_long,
  getNodeCode,
  unique1,
  getNodeCode_topic,
} from "../../assets/js/common";
import { TimestampToTime } from "../../config/common";
import bus from "../../plugins/Bus";
// import app_cloud_work from "../job/app_cloud_work";
// import app_cloud_work_syn from "../job/app_cloud_work_syn";

export default {
  // components: { app_cloud_work,app_cloud_work_syn },
  data() {
    return {
      //2.0
      active_head: 1,
      popover_sort_show: false,
      starttime_sort: "",
      end_time_sort: "",
      sort_time: "全部",
      sort_type: "最新时间",
      sort_type_2: "默认",
      sort_2: 0,
      popover_operation_show: false,
      total: 0,
      getQs_pageNum: 1,
      pageSize: 12,
      order: 0,
      sort: 4,
      keyword: "",
      myDiscussList: [],
    };
  },
  watch: {},
  methods: {
    to_coach_forum(item) {
      console.log(item);
      sessionStorage.coach_data = JSON.stringify(item);
      sessionStorage.setItem("coach_data", JSON.stringify(item));
      this.$router.push({
        path: "/coach/coach_forum",
        query: { type: this.active_head },
      });
    },

    TimestampToTime(time) {
      return TimestampToTime(time);
    },
    changePage(page) {
      this.getQs_pageNum = page;
      if (this.active_head == 1) {
        this.get_myDiscussList();
      } else {
        this.get_myFollowList();
      }
    },
    change_sort_time(type) {
      this.popover_sort_show = false;
      this.sort_time = type;
      if (type == "全部") {
        this.order = 0;
      } else if (type == "习题") {
        this.order = 1;
      } else {
        this.order = 2;
      }
      this.get_myDiscussList();
    },
    change_sort_type(type) {
      this.popover_sort_show = false;
      this.sort_type = type;
      if (type == "最多浏览") {
        this.sort = 1;
      } else if (type == "最多回复") {
        this.sort = 2;
      } else if (type == "最新更新") {
        this.sort = 3;
      } else if (type == "最新时间") {
        this.sort = 4;
      }
      this.get_myDiscussList();
    },
    change_sort_type_2(type) {
      this.popover_sort_show = false;
      this.sort_type_2 = type;
      if (type == "默认") {
        this.sort_2 = 0;
      } else if (type == "最新发布") {
        this.sort_2 = 1;
      } else if (type == "最多关注") {
        this.sort_2 = 2;
      } else if (type == "最多回复") {
        this.sort_2 = 3;
      } else if (type == "最新浏览") {
        this.sort_2 = 4;
      } else if (type == "最新更新") {
        this.sort_2 = 5;
      } else if (type == "最新时间") {
        this.sort_2 = 6;
      }
      this.get_myFollowList();
    },
    btnsearch() {
      this.getQs_pageNum = 1;
      if (this.active_head == 1) {
        this.get_myDiscussList();
      } else {
        this.get_myFollowList();
      }
    },
    get_myDiscussList() {
      var formData = new FormData();
      formData.append("sort", this.sort);
      formData.append("subject_code", sessionStorage.subject_code);
      formData.append("type", this.order);
      formData.append("current_page", this.getQs_pageNum);
      formData.append("page_size", this.pageSize);
      formData.append("keyword", this.keyword);
      this.axios
        .post("/school/Discuss_Info/myDiscussListForTeacher", formData)
        .then((res) => {
          if (res.data.code == 1) {
            this.myDiscussList = res.data.data.data;
            this.total = res.data.data.count;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
              duration: 500,
              showClose: true,
            });
          }
        });
    },
    get_myFollowList() {
      var formData = new FormData();
      formData.append("sort", this.sort_2);
      formData.append("subject_code", sessionStorage.subject_code);
      formData.append("current_page", this.getQs_pageNum);
      formData.append("page_size", this.pageSize);
      formData.append("keyword", this.keyword);
      this.axios.post("/school/discuss/myFollowList", formData).then((res) => {
        if (res.data.code == 1) {
          this.myDiscussList = res.data.data.data;
          this.total = res.data.data.count;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 500,
            showClose: true,
          });
        }
      });
    },
  },

  mounted() {
    this.get_myDiscussList();
    // this.get_myFollowList()
  },
  beforeDestroy() {},
};
</script>

<style >
.course_search .el-input-group__append {
  border-radius: 0 20px 20px 0;
}
.course_search .el-input__inner {
  border-radius: 20px 0 0 20px;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 14px !important;
}
.course_search .el-input {
  height: 40px;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.course_card_empty {
  background: url(../../assets/images/course_2.0/老师.png);
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200px auto;
}
.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}
.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}
.color_active {
  color: #ff9b36 !important;
}
</style>
<style scoped>
.wrapper_app_job {
  /* height: ; */
  /* background: red; */
}
.head {
  height: 60px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
}
.head > div {
  height: 26px;
  line-height: 26px;
  margin: 17px 0 0 0;
  border-bottom: 4px solid transparent;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.active_head_color {
  color: #69b4ff !important;
  border-color: #69b4ff !important;
}
.content_box {
  background: #ffffff;
  padding: 10px;
  margin-top: 14px;
  border-radius: 12px;
  height: calc(100vh - 240px);
  display: flex;
  flex-direction: column;
}
.content_box_search {
  display: flex;
  justify-items: center;
  justify-content: space-between;
}

.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.content_list_box {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 20px;
  margin-bottom: 10px;
  justify-content: space-between;
}
.content_list_page {
  text-align: right;
}
.content_list_item {
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: calc(50% - 10px);
  height: 230px;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 6px 20px 20px 6px;
  border: 5px solid #69b4ff;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 20px;
  position: relative;
}
.content_list_item_title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  height: 18px;
  line-height: 18px;
  margin-bottom: 10px;
}
.content_list_item_content {
  flex: 1;
  overflow: auto;
}
.content_list_item_foot {
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  line-height: 30px;
  display: flex;
}
.content_list_item_foot > div:nth-of-type(1) {
  margin-right: 20px;
}
.content_list_item_foot > div:nth-of-type(2) {
  margin-right: 20px;
}
.content_list_item_foot > div:nth-of-type(4) {
  margin-left: auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.item_type {
  width: 85px;
  height: 40px;
  border-radius: 0 20px 0 20px;
  background: #ff9b36;
  color: white;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  right: -5px;
  top: -5px;
}
</style>
